import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { deleteSolrCollection, getSolrCollections } from '../../../actions';
import { Link, useHistory } from 'react-router-dom';
import { Icon } from '@plone/volto/components';
import deleteSVG from '@plone/volto/icons/delete.svg';

const SolrCollections = () => {
  const dispatch = useDispatch();
  const history = useHistory();

  const items = useSelector((state) => state.solrcollection?.result ?? []);
  const [deleteCollection, setDeleteCollection] = useState('');

  useEffect(() => {
    if (deleteCollection) {
      dispatch(deleteSolrCollection({ uid: deleteCollection }));
      setDeleteCollection('');
      history.push('/search');
      //noinspection JSUnresolvedFunction
      window.location.reload(false);
    }

    dispatch(getSolrCollections());
  }, [dispatch, history, deleteCollection, setDeleteCollection]);

  //noinspection JSUnusedLocalSymbols
  return (
    <>
      {items
        ? Array.from(items).map((entry, index) => {
            return (
              <div key={index} className={'solrcollection-entry'}>
                <Link
                  className={'solrcollection-title'}
                  to={'search?uid=' + entry.uid}
                >
                  {entry.title}
                </Link>
                <Icon
                  className={'solrcollection-delete'}
                  name={deleteSVG}
                  size="18px"
                  onClick={() => setDeleteCollection(entry.uid)}
                ></Icon>
              </div>
            );
          })
        : null}
    </>
  );
};

export default SolrCollections;
